import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { toRoman } from 'helpers'

import { Tooltip } from 'react-wot-bootstrap'

import LackOfIndustrialResource from 'components/LackOfIndustrialResource/LackOfIndustrialResource.jsx'
import IndustrialResource from 'components/IndustrialResource/IndustrialResource.jsx'

import {
    COMMAND_CENTER_MODERNIZATION_DESCRIPTION_ALLOWED,
    NOT_ENOUGH_BUILDINGS_LEVEL,
    MODERNIZATION_TOOLTIP_TITLE,
    COMMAND_CENTER_MODERNIZATION_DESCRIPTION,
    MODERNIZATION_NOT_AVAILABLE_TITLE,
    NOT_ENOUGH_BUILDINGS_LEVEL_DESCRIPTION,
} from './constants.jsx'

import {
    checkBuildingsLevelSumm,
    getNecessaryBuildingsLevel,
} from 'helpers/stronghold'

import styles from './UpgradeTooltip.scss'

export const UpgradeTooltip = (props) => {
    let description = (
        <div className={styles.description}>
            {COMMAND_CENTER_MODERNIZATION_DESCRIPTION_ALLOWED(
                <span className={styles.valueHighlight}>{toRoman(props.nextLevel)}</span>
            )}
        </div>
    )

    let message
    let divider

    if (!props.isBuildingsLevelEnough) {
        const necessaryLevelComponent = (
            <span className={styles.valueHighlight}>{props.necessaryBuildingsLevel}</span>
        )
        message = (
            <div>
                <p className={styles.messageTitle}>{MODERNIZATION_NOT_AVAILABLE_TITLE}</p>
                <p className={styles.messageDescription}>{NOT_ENOUGH_BUILDINGS_LEVEL(necessaryLevelComponent)}</p>
                <p className={styles.messageDescription}>
                    {NOT_ENOUGH_BUILDINGS_LEVEL_DESCRIPTION}
                </p>
            </div>
        )
    } else if (props.industrialResourceAvailable < props.upgradeCost) {
        const industrialResource = (
            <IndustrialResource
                value={props.upgradeCost - props.industrialResourceAvailable}
                small
            />
        )
        message = <LackOfIndustrialResource resource={industrialResource} />
    }

    if (props.industrialResourceAvailable < props.upgradeCost || !props.isBuildingsLevelEnough) {
        divider = <div className={styles.divider}/>

        description = (
            <div className={styles.message}>
                {COMMAND_CENTER_MODERNIZATION_DESCRIPTION(
                    <span className={styles.valueHighlight}>{toRoman(props.nextLevel)}</span>
                )}
            </div>
        )
    }

    return (
        <Tooltip id={props.id} isWide>
            <div className={styles.base}>
                <p className={styles.title}>
                    {MODERNIZATION_TOOLTIP_TITLE}
                </p>
                {description}
                {divider}
                {message}
            </div>
        </Tooltip>
    )
}

UpgradeTooltip.propTypes = {
    id: PropTypes.string.isRequired,
    nextLevel: PropTypes.number.isRequired,
    upgradeCost: PropTypes.number.isRequired,
    industrialResourceAvailable: PropTypes.number.isRequired,
    necessaryBuildingsLevel: PropTypes.number.isRequired,
    isBuildingsLevelEnough: PropTypes.bool.isRequired,
}

export const mapStateToProps = (state, { id }) => {
    const upgradeCost = state.settings.command_center.costs[state.stronghold.level]

    return {
        id,
        nextLevel: (state.stronghold.level + 1),
        upgradeCost,
        industrialResourceAvailable: state.clan.industrial_resource,
        necessaryBuildingsLevel: getNecessaryBuildingsLevel(state),
        isBuildingsLevelEnough: checkBuildingsLevelSumm(state),
    }
}

export default connect(mapStateToProps)(UpgradeTooltip)



// WEBPACK FOOTER //
// ./containers/CommandCenterCard/components/UpgradeTooltip/UpgradeTooltip.jsx